import { PageHeader } from "@/CommonElements/PageTitle";
import { HousingInspectionOrderForm } from "./HousingInspectionOrderForm";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import BtnAsLink from "@/Component/BtnAsLink";
import { HugeiconsIcon } from "@hugeicons/react";
import { Edit02Icon } from "@hugeicons/core-free-icons/index";

export const EditHousingInspection = () => {
  const { t } = useTranslation();
  const { mode, house_contract_id, houseComrRegNo, order_number } = useParams();
  const isViewMode = mode === "view";
  return (
    <div>
      <PageHeader
        title={
          isViewMode
            ? t("VIEW_HOUSING_INSPECTION")
            : t("EDIT_HOUSING_INSPECTION")
        }
        sticky={false}
      >
        {isViewMode && (
          <BtnAsLink
            link={`/app/makkah/housing-inspection/${house_contract_id}/${houseComrRegNo}/${order_number}/edit`}
            icon={<HugeiconsIcon size={18} icon={Edit02Icon} />}
            className="btn btn-outline-primary "
          >
            {t("EDIT_HOUSING_INSPECTION")}
          </BtnAsLink>
        )}
      </PageHeader>
      <Container fluid>
        <HousingInspectionOrderForm />
      </Container>
    </div>
  );
};
